export default "<canvas id=\"revenueChart\"></canvas>\r\n"